import { useState, useEffect } from "react";

export default function ImpactSection() {
  const [isHovered, setIsHovered] = useState(false);
  const [current, setCurrent] = useState(0);

  const items = [
    {
      stat: "80%",
      title: "Less Manual Data Entry",
      desc: "Eliminate repetitive document handling with AI-powered automation.",
    },
    {
      stat: "5×",
      title: "Faster Doc Processing",
      desc: "Process reports, forms, and contracts in minutes instead of hours.",
    },
    {
      stat: "99%",
      title: "Data Extraction Accuracy",
      desc: "Ensure reliable, structured data for faster and better business decisions.",
    },
  ];

  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % items.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [isHovered, items.length]);

  return (
    <div className="w-full py-12">
      <div className="container-width">
        {/* Heading */}
        <div className="mb-10 text-center ">
          <h2 className="text-2xl md:text-4xl font-semibold text-center tracking-tight text-neutral-950">
            Transform How Your Business Handles Documents
          </h2>
        </div>

        {/* Card */}
        <div className="w-full bg-gray-100 rounded-[4px] p-8 md:p-12">
          {/* ✅ Desktop */}
          <div className="hidden md:grid grid-cols-3 gap-8">
            {items.map((item, i) => (
              <div
                key={i}
                className="text-center border-l first:border-l-0 pl-8"
              >
                {/* BIG STAT */}
                <div className="text-2xl md:text-4xl font-bold text-primary mb-3">
                  {item.stat}
                </div>

                {/* TITLE */}
                <h3 className="text-lg md:text-xl font-semibold text-neutral-950 mb-3">
                  {item.title}
                </h3>

                {/* DESCRIPTION */}
                <p className="text-sm md:text-base text-neutral-600">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* ✅ Mobile Carousel */}
          <div className="md:hidden">
            <div
              className="relative overflow-hidden"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${current * 100}%)` }}
              >
                {items.map((item, i) => (
                  <div key={i} className="min-w-full text-center px-4">
                    {/* BIG STAT */}
                    <div className="text-5xl font-bold text-primary mb-3">
                      {item.stat}
                    </div>

                    {/* TITLE */}
                    <h3 className="text-lg font-semibold text-neutral-950 mb-3">
                      {item.title}
                    </h3>

                    {/* DESCRIPTION */}
                    <p className="text-sm text-neutral-600">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
